import script from "./RubiksCube.vue?vue&type=script&setup=true&lang=js"
export * from "./RubiksCube.vue?vue&type=script&setup=true&lang=js"

import "./RubiksCube.vue?vue&type=style&index=0&id=7f5469e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5469e5"]])

export default __exports__